import { useUserWithCompany } from '@app/hooks/useUserWithCompany';
import PostAddIcon from '@mui/icons-material/PostAdd';
import SchoolIcon from '@mui/icons-material/School';
import { Button, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomTrainingsModal } from './CustomTrainings';
import { EmployeeTable } from './EmployeeTable';
import './training.sass';

export function Training() {
  const { activeCompany } = useUserWithCompany();
  const { t } = useTranslation();
  const [customTrainingsOpen, setCustomTrainingsOpen] = useState(false);

  const n = activeCompany?.employees?.filter((e) => !e.archivedAt).length || 0;
  const max = activeCompany?.maxEmployees ?? undefined;

  return (
    <div className="dtTraining flex flex-col gap-[10px]">
      <div className="dtRouteDashboard__itemTitle flex flex-row items-center gap-[10px]">
        <SchoolIcon />
        <div className="dtRouteDashboard__itemTitleInput" style={{ width: 'auto' }}>
          {t('dashboard.training.title')}
        </div>
        <span className="whitespace-nowrap text-2xl">
          {max ? (
            <>
              {n} / {max}
            </>
          ) : (
            n
          )}
        </span>
        <div className="grow" />
        <Tooltip
          title={t(
            'dashboard.training.custom.open_tooltip',
            'Eigene Schulungen verwalten (z. B. interne Richtlinien zur Kenntnisnahme)'
          )}
        >
          <Button
            variant="outlined"
            size="small"
            startIcon={<PostAddIcon />}
            onClick={() => setCustomTrainingsOpen(true)}
            data-testid="open-custom-trainings-button"
            sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}
          >
            {t('dashboard.training.custom.open_label', 'Eigene Schulungen')}
          </Button>
        </Tooltip>
      </div>
      <EmployeeTable />
      <CustomTrainingsModal open={customTrainingsOpen} onClose={() => setCustomTrainingsOpen(false)} />
    </div>
  );
}
